import React from 'react';

import styles from './userNotificationsShowPageStyles.scss';

import EmailSubscriptionFormContainer from 'buyside/components/container/UserAccount/EmailSubscriptionFormContainer';

import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import { useCurrentUserAccountNotificationShowPageQuery } from 'interfaces/graphql-typings';

const UserNotificationsShowPage = (): React.ReactElement => {
  const { loading, data } = useCurrentUserAccountNotificationShowPageQuery();

  if (loading || !data?.currentUser) return <LoadingSpinner size={SIZES.LARGE} />;

  return (
    <>
      <div className={styles.pageTitle}>Email Notifications</div>
      <EmailSubscriptionFormContainer currentUser={data.currentUser} />
    </>
  );
};

export default UserNotificationsShowPage;
